import { render, staticRenderFns } from "./sy-info.vue?vue&type=template&id=4a12a1c6&scoped=true&"
import script from "./sy-info.vue?vue&type=script&lang=js&"
export * from "./sy-info.vue?vue&type=script&lang=js&"
import style0 from "./sy-info.vue?vue&type=style&index=0&id=4a12a1c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a12a1c6",
  null
  
)

export default component.exports